import { render, staticRenderFns } from "./AgencyCommissionRules.vue?vue&type=template&id=63207cf6&scoped=true&"
import script from "./AgencyCommissionRules.vue?vue&type=script&lang=js&"
export * from "./AgencyCommissionRules.vue?vue&type=script&lang=js&"
import style0 from "./AgencyCommissionRules.vue?vue&type=style&index=0&id=63207cf6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63207cf6",
  null
  
)

export default component.exports